import React, { useState, useEffect } from "react";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "../ui/card";
import { getStudentClassSchedule } from "../../lib/api";

const DAY_COLORS = {
  monday: "#2563EB", tuesday: "#D97706", wednesday: "#475569", thursday: "#7C3AED", friday: "#059669",
};
const DAY_LABELS = { monday: "Mon", tuesday: "Tue", wednesday: "Wed", thursday: "Thu", friday: "Fri" };

export function StudentClassScheduleSection({ studentId }) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!studentId) return;
    getStudentClassSchedule(studentId)
      .then(res => setData(res.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [studentId]);

  if (loading) return null;
  if (!data || !data.class_schedule || data.message) return null;

  const days = Object.keys(data.class_schedule).filter(d => data.class_schedule[d].length > 0);
  if (days.length === 0) return null;

  return (
    <Card data-testid="student-class-schedule">
      <CardHeader>
        <CardTitle className="text-base">Class Schedule</CardTitle>
        <CardDescription>
          From: {data.schedule_name} ({data.schedule_dates})
          {data.morning_group && <span className="ml-2">| Morning: {data.morning_group}</span>}
          {data.afternoon_group && <span className="ml-2">| Afternoon: {data.afternoon_group}</span>}
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className="overflow-x-auto">
          <table className="w-full border-collapse text-sm">
            <thead>
              <tr>
                <th className="border p-2 bg-gray-100 text-xs">Block</th>
                {days.map(d => (
                  <th key={d} className="border p-2 text-white text-xs" style={{ background: DAY_COLORS[d] }}>
                    {DAY_LABELS[d]}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {(() => {
                const allBlocks = new Set();
                days.forEach(d => data.class_schedule[d].forEach(c => allBlocks.add(c.block)));
                return [...allBlocks].sort().map(block => (
                  <tr key={block}>
                    <td className="border p-2 bg-gray-50 text-xs font-medium">{block.replace("block", "Block ")}</td>
                    {days.map(d => {
                      const cls = data.class_schedule[d].find(c => c.block === block);
                      return (
                        <td key={d} className="border p-2 text-xs" style={{ background: cls ? `${DAY_COLORS[d]}10` : "" }}>
                          {cls ? (
                            <div>
                              <p className="font-semibold" style={{ color: DAY_COLORS[d] }}>{cls.subject}</p>
                              {cls.lead && <p className="text-gray-500">{cls.lead}</p>}
                              {cls.location && <p className="text-gray-400">{cls.location}</p>}
                            </div>
                          ) : <span className="text-gray-300">--</span>}
                        </td>
                      );
                    })}
                  </tr>
                ));
              })()}
            </tbody>
          </table>
        </div>
      </CardContent>
    </Card>
  );
}
